import { Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { useDialog } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { ResourceDialog, ResourceDto } from "./ResourceDialog";

export function ResourceListPage() {
    const [useStore] = useState(() => createListStore<ResourceDto>({
        path: "settings/resources",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "name", label: "Name", width: 500, sortable: true, filter: true, filterWidth: 3 },
            { column: "language", label: "Language", width: 80 },
            { column: "stringValue", label: "Value", flex: 1, filter: true, filterWidth: 3 },
        ],
    }));

    const { selectedItem } = useStore(p => ({ selectedItem: p.selectedItem }));
    const editDialog = useDialog(close => <ResourceDialog close={close} item={selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch({ unintrusive: true }); }} />, "xs");
    return <>
        {editDialog.render()}
        <PageTitle title="Resources" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
            ]),
        })}
    </>;
}
